import { STATIC_STRINGS } from "@asez/shared";
import { FILTER_KEYS } from "@asez/shared";
import { FilterListItem } from "./FilterListItem";
import { initialFilters } from "./index";
import { RangeSlider } from "./RangeSlider";

export const TrustFilter = ({ filters, updateFilters }) => {
  return (
    <FilterListItem
      filterName={STATIC_STRINGS.TRUST_SCORE}
      resetHandler={() => {
        updateFilters(
          FILTER_KEYS.TRUST_SCORE,
          initialFilters[FILTER_KEYS.TRUST_SCORE]
        );
      }}
      Component={
        <RangeSlider
          filters={filters}
          filterKey={FILTER_KEYS.TRUST_SCORE}
          updateFilters={updateFilters}
        />
      }
    />
  );
};
